<template>
  <div class="row transaction">
    <!-- top items start -->
    <div class="form-row align-items-end d-flex w-100">
      <div class="col-auto">
        <label>Start Date</label>
        <div class="input-group mb-2">
          <input
            type="date"
            class="form-control"
            id="inlineFormInputGroup"
            placeholder="Start Date"
            v-model="startDate"
          />
        </div>
      </div>

      <div class="col-auto">
        <label>End Date</label>
        <div class="input-group mb-2">
          <input
            type="date"
            class="form-control"
            id="inlineFormInputGroup"
            placeholder="End Date"
            v-model="endDate"
          />
        </div>
      </div>

      <div class="col-auto">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('filter')"
        >
          Filter
        </button>
      </div>
      <div class="col-auto">
        <button
          type="submit"
          class="btn btn-primary mb-2 mt-4"
          @click="refresh('download')"
        >
          Download Logs
        </button>
      </div>

      <div class="col-auto search-bar mb-2">
        <label for="search-input">Search:</label>
        <input type="text" class="form-control" id="" v-model="searchQuery" />
      </div>

      <div class="col-auto mb-2 pl-2">
        <button class="btn btn-info" @click="refresh('refresh')">
          Refresh
        </button>
      </div>
    </div>
    <!-- top items end -->
    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Activity</th>
                <th scope="col" class="text-center">Initiated By</th>
                <th scope="col" class="text-center">Date</th>
                <th scope="col" class="text-center">Time</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(log, index) in filteredLogs" :key="log._id">
                <th class="text-center">
                  {{ limit * (page - 1) + (index + 1) }}
                </th>
                <td class="text-center">{{ log.activity }}</td>
                <td class="text-center">{{ log.initiatedBy }}</td>
                <td class="text-center">
                  {{ moment(log.createdAt).format("D-MM-Y") }}
                </td>
                <td class="text-center">
                  {{ moment(log.createdAt).format("h:mm:ss a") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div class="pagination" style="justify-content: space-between; width: 100%">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>

    <!-- <div class="mt-2 d-flex justify-content-end align-items-center">
			<div class="p-2" v-if="hasPrevPage === true">
				<button
					type="submit"
					class="btn btn-primary mb-2 mt-4"
					@click="refresh('previous')"
				>
					Previous Page
				</button>
			</div>
				<div style="padding: 0 8px;">Page {{ currentPage }} of {{ totalPages }}</div>
			<div class="p-2" v-if="hasNextPage === true">
				<button
					type="submit"
					class="btn btn-primary mb-2 mt-4"
					@click="refresh('next')"
				>
					Next Page
				</button>
			</div>
      <div class="mt-3 d-flex justify-content-end align-items-center">
						<div class="btn">Total Records: {{ totalDocs }}</div>
				</div>
		</div> -->
  </div>
</template>
<script>
import axios from "../store/axios";
import { convertArrayToCSV } from "convert-array-to-csv";
import fileDownload from "js-file-download";
import moment from "moment";

export default {
  data() {
    return {
      error: false,
      errorMsg: "",
      loading: false,
      moment,
      totalDocs: 0,
      limit: 50,
      page: 1,
      totalPages: 0,
      currentPage: 1,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
      startDate: moment().format("DD-MM-YYYY"),
      endDate: moment().format("DD-MM-YYYY"),
      logs: [],
      searchQuery: "",
    };
  },
  computed: {
    filteredLogs() {
      const filtered = this.logs.filter((log) => {
        const activityMatch = log.activity
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const nameMatch = log.initiatedBy
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        return activityMatch || nameMatch;
      });
      if (filtered.length) {
        return filtered;
      } else {
        return [
          { activity: "No record found", initiatedBy: "No record found" },
        ];
      }
    },
  },
  methods: {
    async refresh(mode) {
      try {
        this.errorMsg = "";
        this.error = false;
        this.loading = true;
        let payload = {
          page: this.page,
          startDate: this.startDate,
          endDate: this.endDate,
          limit: this.limit,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
          case "refresh":
            this.startDate = "";
            this.endDate = "";
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/activity-log/list`,
          payload,
        );
        if (mode === "download") {
          const csvTran = convertArrayToCSV(res.data.logs);
          fileDownload(csvTran, "activity_logs.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
            totalDocs,
            page,
          } = res.data.logs;
          this.logs = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
          this.totalDocs = totalDocs;
          this.page = page;
        }
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Fetch Activities";
      }
      this.loading = false;
    },
  },
  async mounted() {
    try {
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/activity-log/list`,
        {
          page: this.page,
          startDate: this.startDate,
          endDate: this.endDate,
          limit: this.limit,
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.logs;
      this.logs = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Activities";
    }
    this.loading = false;
  },
};
</script>

<style scoped>
.transaction {
  font-size: 12px;
}
.top-section {
  display: flex !important;
  width: 90% !important;
}
.search-bar {
  float: right !important;
}
#search-input {
  width: 80%;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
#list {
  list-style-type: none;
}
tbody {
  background: #fff !important;
}
</style>
